import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const TIERS = [{
  id: 1,
  name: 'SCHOOL SPIRIT MODE 🎓',
  color: 'bg-blue-500',
  borderColor: 'border-blue-500',
  textColor: 'text-blue-400',
  desc: 'Family-safe. Coach approved. Still absolutely merciless about your picks.',
  tag: 'Perfect for school leagues & fundraisers',
  quote: 'Hinge Hunters fell 30 points short this week! Great effort though, team! 🎉'
}, {
  id: 2,
  name: 'STADIUM 🏟️',
  color: 'bg-slate-400',
  borderColor: 'border-slate-400',
  textColor: 'text-slate-300',
  desc: 'Rowdy crowd energy. PG-13. Your grandma could technically listen.',
  tag: 'Best for office leagues',
  quote: 'Hinge Hunters got absolutely worked. Josh Allen did NOT come to play for YOU.'
}, {
  id: 3,
  name: 'SPORTS BAR 🍺',
  color: 'bg-orange',
  borderColor: 'border-orange',
  textColor: 'text-orange',
  desc: 'No filter. This is where it gets good.',
  tag: 'Most popular',
  quote: "Someone's picking fantasy players the way they pick dates on Hinge — completely blindly."
}, {
  id: 4,
  name: 'AFTER DARK 🔥',
  color: 'bg-crimson',
  borderColor: 'border-crimson',
  textColor: 'text-crimson',
  desc: "You've been warned. Not for the faint of heart.",
  tag: 'Adults only — unlock at checkout',
  quote: 'LOCKED — After Dark unlocks at checkout',
  isLocked: true
}];
export const HilariousMeter = () => {
  const [activeTier, setActiveTier] = useState(3);
  return <div className="w-full max-w-6xl mx-auto" data-id="element-32">
      {/* Cards Row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-12" data-id="element-33">
        {TIERS.map(tier => <button key={tier.id} onClick={() => setActiveTier(tier.id)} className={`relative text-left p-6 rounded-2xl border-2 transition-all duration-300 flex flex-col ${activeTier === tier.id ? `${tier.borderColor} bg-dark shadow-[0_0_30px_rgba(0,0,0,0.5)] scale-105 z-10` : 'border-white/10 bg-charcoal hover:border-white/30 opacity-70 hover:opacity-100'}`} data-id="element-34">
            <div className="mb-4" data-id="element-35">
              <span className={`text-xs font-bold uppercase tracking-wider ${tier.textColor}`} data-id="element-36">
                Tier {tier.id}
              </span>
              <h3 className="font-heading font-black text-2xl mt-1" data-id="element-37">
                {tier.name}
              </h3>
            </div>
            <p className="text-sm text-slate mb-6 flex-1" data-id="element-38">{tier.desc}</p>
            <div className="mt-auto" data-id="element-39">
              <span className="inline-block bg-white/5 px-3 py-1 rounded text-xs font-mono text-white/70" data-id="element-40">
                {tier.tag}
              </span>
            </div>

            {/* Active Indicator */}
            {activeTier === tier.id && <motion.div layoutId="activeIndicator" className={`absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 rotate-45 ${tier.color}`} data-id="element-41" />}
          </button>)}
      </div>

      {/* Quote Display */}
      <div className="relative max-w-3xl mx-auto" data-id="element-42">
        <AnimatePresence mode="wait" data-id="element-43">
          <motion.div key={activeTier} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className={`p-8 rounded-3xl border-2 bg-dark text-center relative overflow-hidden ${TIERS[activeTier - 1].borderColor}`} data-id="element-44">
            <div className={`absolute inset-0 opacity-10 ${TIERS[activeTier - 1].color}`} data-id="element-45"></div>

            <div className="relative z-10" data-id="element-46">
              <p className="text-sm font-bold uppercase tracking-wider mb-4 text-slate" data-id="element-47">
                Sample Commentary
              </p>

              {TIERS[activeTier - 1].isLocked ? <div className="py-8" data-id="element-48">
                  <p className="text-2xl md:text-4xl font-heading font-black italic blur-sm select-none text-white/50" data-id="element-49">
                    "This is way too explicit to show on a public marketing
                    website."
                  </p>
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-50">
                    <span className="bg-crimson text-white px-6 py-3 rounded-full font-bold uppercase tracking-wider shadow-xl flex items-center gap-2" data-id="element-51">
                      🔒 {TIERS[activeTier - 1].quote}
                    </span>
                  </div>
                </div> : <p className="text-2xl md:text-4xl font-heading font-black italic text-white leading-tight" data-id="element-52">
                  "{TIERS[activeTier - 1].quote}"
                </p>}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
};